import { Link } from 'react-router-dom';

import CompanySwitcher from './components/viewCompanyForNavigation/CompanySwitcher';
import { useUserRoles } from '@/app/user/_hooks';

// The brand control at the top of the navigation rail: always the Zebel logo.
// Zebelers additionally get a dropdown to switch between company accounts.
const ViewCompanyForNavigation = () => {
  const { isZebeler } = useUserRoles();

  if (isZebeler) {
    return <CompanySwitcher />;
  }

  return (
    <Link to="/" data-testid="nav-zebel-logo" className="flex size-11 items-center justify-center rounded-xl hover:bg-accent transition-colors">
      <img src="/assets/logos/zebel/icon.png" alt="Zebel" className="size-10 rounded-xl" />
    </Link>
  );
};

export default ViewCompanyForNavigation;
